// import tttrang from "./tttrang.png";
import hvtdung from "./hvtdung.jpg";
// import razvan from "./Razvan.png";
import soumen from "./soumen.jpeg";
import hdkhoa from "./hdkhoa.png";
const keynote = [
  {
    img: soumen,
    name: "Dr. Soumen Banerjee",
    scope: "Deep Learning Wireless Communications",
    detail: "Deep Learning and Wireless Communication Technologies for Emerging Applications",
    link: "/keynote",
  },
  {
    img: hvtdung,
    name: "Dr. Huynh Vo Trung Dung",
    scope: "AI in Telecommunications.",
    detail:
      "Shattering the Noise Barrier: Why Teamwork is the Future of AI in Telecommunications.",
    link: "/keynote",
  },
  {
    img: hdkhoa,
    name: "Dr. Khoa Dang Hoang",
    scope: "AI in Electrical Engineering",
    detail:
      "AI applications in power conversion systems",
    link: "/keynote",
  },
];
export default keynote;
